module.exports = __webpack_public_path__ + "static/media/motorboat_selected_ic.8a00f945.svg";